import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { disableFuelingService } from '../../api/fueling-service.ts';

export default function useDisableFuelingService(): UseMutationResult<
  Awaited<ReturnType<typeof disableFuelingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => disableFuelingService(serviceId),
  });
}
